import Constants from 'expo-constants'
import { ConstantsExtra } from '../types/appConfig'

export const constantsExtra = Constants.manifest.extra as ConstantsExtra
